import JsonLd from "@/components/JsonLd.tsx";
import JsonLdBreadcrumbList from "@/components/JsonLdBreadcrumbList.tsx";
import {createFileRoute, useLoaderData} from '@tanstack/react-router'
import {apiRetrieveImproved} from '@/api.ts'
import BlogPage from '../../landing/BlogPage'
import {PostType} from '@/constants.ts'
import {Post} from '@/types'

export const Route = createFileRoute('/blog/')({
    loader:    async () => {
        const posts = await apiRetrieveImproved('public-blog', {type: PostType.Blog}) as Post[];
        return {posts};
    },
    component: RouteComponent,
})

function RouteComponent() {
    const {posts} = useLoaderData({from: '/blog/'});
    return <>
        <JsonLd id={`page${Route.id}/blog`} item={{
            "@context":    "https://schema.org",
            "@type":       "Article",
            "headline":    "ScorePal Blog",
            "url":         "https://scorepal.co/blog/",
            "description": "Insights, updates, and guides on sports tournament management, live scoring systems, and club operations powered by ScorePal.",
            "author":      {
                "@type": "Organization",
                "name":  "ScorePal"
            },
            "publisher":   {
                "@type": "Organization",
                "name":  "ScorePal"
            }
        }} />
        <JsonLdBreadcrumbList routeId={Route.id} crumbs={[{name: "Blog", item: "https://scorepal.co/blog/"}]} />
        <BlogPage initialPosts={posts} />
    </>
}
